<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="overview-wrap">
          <h2 class="title-1">Админ засах</h2>
        </div>
      </div>
    </div>

    <div v-if="admin != null" class="card w-100 mt-3">
      <div class="card-body">
        <div class="row form-group">
          <div class="col-3">
            <label class="form-control-label">Name</label>
          </div>
          <div class="col-9">
            <input type="text" v-model="admin.name" name="text-input" class="form-control" disabled>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-3">
            <label class="form-control-label">Email</label>
          </div>
          <div class="col-9">
            <input
              type="email"
              v-model="admin.email"
              name="text-input"
              class="form-control"
              disabled
            >
          </div>
        </div>
        <div class="row form-group">
          <div class="col-3">
            <label for="select" class="form-control-label">Role</label>
          </div>
          <div class="col-9">
            <select name="select" id="select" v-model="role" class="form-control">
              <option value="0">SUPERADMIN</option>
              <option value="1">Admin</option>
              <option value="2">Content Manager</option>
              <option value="3">Banner Manager</option>
            </select>
          </div>
        </div>
      </div>
      <div class="card-footer d-flex justify-content-end">
        <button @click="onSubmit" class="btn btn-success">
          <i class="fa fa-dot-circle-o"></i> Хадгалах
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/AdminService.js";
import Form from "@/mixins/Form.js";

export default {
  name: "AdminEdit",

  mixins: [Form],

  data() {
    return {
      admin: null,
      role: ""
    };
  },

  created() {
    if (this.$store.getters.loggedAdmin.role != 0) this.$router.push("/admins");

    this.$store.dispatch("setLoading", true);
    this.getAdmin();
  },

  validations: {
    role: {
      serverFailed: function() {
        return !this.hasServerError("role");
      }
    }
  },

  methods: {
    getAdmin() {
      AdminService.getAdmin({}, this.$route.params.id).then(response => {
        if (response.status == 200 && response.data.success == true) {
          this.admin = response.data.payload;
          this.role = this.admin.role;
        }
        this.$store.dispatch("setLoading", false);
      });
    },

    serverRequest: AdminService.changeRole,

    successHandler(response) {
      if (response.data.payload.toast !== null)
        this.showToast(response.data.payload.toast);

      this.$router.push("/admins");
    },

    createJsonData() {
      const data = JSON.parse("{}");
      data.id = this.$route.params.id;
      data.role = this.role;
      return data;
    }
  }
};
</script>
